export default __webpack_public_path__ + "static/media/ic_session_timer.5e668293.svg";